import moduleTwoLegged from './two-legged';

export default {
  namespaced: true,
  modules: {
    twoLegged: moduleTwoLegged,
  },
};
